import { type ISchedule, isParking } from "@gettactic/api";
import { getScheduleAttendeeSlots } from "@gettactic/helpers/src/schedules/getScheduleAttendees";

/**
 * The attendees the edit form starts from, one entry per person.
 *
 * The form edits either the parking side of a reservation or everything else, so the
 * slots are narrowed to the matching kind first. A multi-room reservation then holds one
 * slot per room *per attendee*, so those have to collapse to one entry per person —
 * otherwise the same guest is listed once per room, and sent back that way on save.
 */
export const getEditedReservationAttendeeIds = (
  schedule: ISchedule,
  isPrimaryParking: boolean
): string[] =>
  getScheduleAttendeeSlots({
    slots: schedule.slots.filter((slot) =>
      isPrimaryParking ? isParking(slot.resource) : !isParking(slot.resource)
    )
  }).map((slot) => slot.user.id);
